// extracted by mini-css-extract-plugin
export default {"wrap":"kNKQcLV01kARTktTLKSJ","clickable":"mddvDx1Kfnr0oo_J68Im","text":"hu9lMX5hc3GOVMfCibdu","icon":"cLtf2UxSFum1yERlpCRk","error":"XyfMQV3W_Gz44J9b2bzy"};